/**
* @module index
* @author: zhangyemei
* @description:
* @since: 2020-05-23 17:52:42
*/
import React, { Component } from 'react';
import { Decrypt, Encrypt } from '@/utils/encrypt.js';
import { Dropdown, Menu } from 'antd';
import { Local } from '@/utils/local.js';
import history from '@/router/history';
import './style.less';
export default class index extends Component {
  state = {
    userId: Local.get('userInfo') && JSON.parse(Decrypt(Local.get('userInfo'))).userId ? Number(JSON.parse(Decrypt(Local.get('userInfo'))).userId) : null,
    baseUrl: window.location.origin,
    baseInfo: this.props.baseInfo,
    schoolList: this.props.schoolList,
    MenuClassName: Local.get('MenuClassName'),
    mainColor: Local.get('main_color')
  };

  componentDidMount() {} // mainColorFun = (schoolName , currentSchoolName) => {
  //   let { mainColor } = this.state;
  //   return schoolName == currentSchoolName ?  {background: "black",color:'white' } : ''
  // }


  render() {
    const {
      MenuClassName,
      mainColor
    } = this.state;
    const {
      schoolList,
      baseInfo,
      showSchoolList,
      currentSchoolName,
      dropVisible
    } = this.props; // console.log('分校信息xxxx',baseInfo)
    //分校列表

    const schoolListMenu = <React.Fragment>
      <Menu data-inspector-line="43" data-inspector-column="6" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" className={`school-menu ${MenuClassName}`}>
          <div data-inspector-line="44" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" className="menu-header">
            <p data-inspector-line="45" data-inspector-column="12" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" className="menu-header-switchSchool">切换分校</p>
            {schoolList.length > 16 ? <p data-inspector-line="46" data-inspector-column="39" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" onClick={() => {
            this.props.history.push("/home/choice");
          }} className="menu-header-hover">更多分校<i data-inspector-line="46" data-inspector-column="134" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" className="iconfont iconyoujiantou"></i></p> : null}
          </div>
          {schoolList.slice(0, 16).map((item, index) => <Menu.Item data-inspector-line="49" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" style={{
          margin: '0px'
        }} key={index} onClick={() => this.props.handleSchoolClick(item, 'changeSchool')}>{item.schoolName}</Menu.Item>)}
      </Menu>
      </React.Fragment>;
    return <div data-inspector-line="56" data-inspector-column="8" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" className="left">
          {
        /*<a className="logo fl" href={`${state.baseUrl}/index`} target="_self">*/
      }
          <a data-inspector-line="58" data-inspector-column="10" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" className="logo fl" onClick={() => history.push('/home/index')}>
            {//机构logo或简称
        baseInfo ? baseInfo.companyLogoType ? baseInfo.companyLogoType == 'word' ? <span data-inspector-line="63" data-inspector-column="20" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx">{baseInfo.companyNameShort ? baseInfo.companyNameShort.slice(0, 8) : ''}</span> : <img data-inspector-line="64" data-inspector-column="20" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" src={baseInfo.companyLogo} alt="" /> : <span data-inspector-line="65" data-inspector-column="22" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx">{baseInfo.companyNameShort ? baseInfo.companyNameShort.slice(0, 8) : ''}</span> : null}
          </a>

          {//分校数量大于1才显示
      schoolList.length > 1 && showSchoolList ? // <Dropdown className="school" overlay={schoolListMenu} trigger={['click']} visible={dropVisible}
      <Dropdown data-inspector-line="73" data-inspector-column="14" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" className="school" overlay={schoolListMenu} overlayClassName={`layout-school-dropdown ${schoolList.length > 8 ? 'dropdown-eight' : ''}`}>
                <span data-inspector-line="75" data-inspector-column="16" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" onClick={this.props.showDorpMenu}>
                  {currentSchoolName}
                  <i data-inspector-line="77" data-inspector-column="18" data-inspector-relative-path="src\\containers\\Layout\\Header\\LogoSchool\\index.jsx" className="iconfont iconxiajiantou"></i>
                </span>
              </Dropdown> : null}
        </div>;
  }

}